const APP_IS_LOADED = 'APP_IS_LOADED'
const IS_USER_ADMIN = 'IS_USER_ADMIN'
const RETURN_TO = 'RETURN_TO'
const SIDEBAR_STATUS = 'SIDEBAR_STATUS'

export default {
  APP_IS_LOADED,
  IS_USER_ADMIN,
  RETURN_TO,
  SIDEBAR_STATUS
}
